export { default } from './OfferDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferDetail/index.js